export const servingTempsTerms = {
    Very_Cold: '0-4°C / 32-39°F',
    Cold: '4-7°C / 39-45°F',
    Cool: '8-12°C / 45-54°F',
    Cellar: '12-14°C / 54-57°F',
    Warm: '14-16°C / 57-61°F',
    Hot: '70°C / 158°F',
}
